import * as React from 'react'

import { LoaderCircleIcon } from '../icons'
import type { IconProps } from '../icons/helpers'

type SimpleSpinnerProps = IconProps

/**
 * A simple spinner component used to indicate loading state
 */
const SimpleSpinner = React.forwardRef<SVGSVGElement, SimpleSpinnerProps>(
  (
    { className, color = 'subtle', ...props }: SimpleSpinnerProps,
    forwardedRef,
  ) => {
    return (
      <LoaderCircleIcon
        ref={forwardedRef}
        color={color}
        className={className}
        {...props}
      />
    )
  },
)

SimpleSpinner.displayName = 'SimpleSpinner'

export { SimpleSpinner }
